import { useEffect, useState } from "react";
import { UseFormReturn } from "react-hook-form";
import { authEventBus } from "../auth.events";
import { Invitation } from "@core/features/invitation";

type Args = {
  invitation: Invitation;
  watch: UseFormReturn<any>["watch"];
};

export function useTrackSignupEvents({ invitation, watch }: Args) {
  const [signupIntentRegistered, setSignupIntentRegistered] = useState(false);

  const [signupStartedRegistered, setSignupStartedRegistered] = useState(false);

  useEffect(() => {
    if (signupIntentRegistered) return;

    authEventBus.emitEvent("auth:signup:intent", { invitation });

    setSignupIntentRegistered(true);
  }, [invitation, signupIntentRegistered]);

  useEffect(() => {
    if (signupStartedRegistered) return;

    const subscription = watch((value) => {
      // Only trigger if user has typed something
      const anyFilled = Object.values(value).some((v) =>
        typeof v === "string" ? v.trim() !== "" : v != null
      );

      if (anyFilled) {
        authEventBus.emitEvent("auth:signup:started", { invitation });
        setSignupStartedRegistered(true);
      }
    });

    return () => subscription.unsubscribe();
  }, [signupStartedRegistered, watch, invitation]);
}

export default useTrackSignupEvents;

